module.exports = __webpack_public_path__ + "static/media/bridesmaid-main-1920-a.a5853a4c.jpg";